export const TASTING_CERTIFICATE_IMAGE =
    'https://simplewine.ru/static/local/assets/images/degustations/degustations-certificate.jpg';
export const TASTING_CERTIFICATE_BUTTON_LINK_HREF = 'https://simplewine.ru/electronic-gift-certificates/';

export const MODAL_TITLE = 'Правила использования';

export const CERTIFICATE_RULES = [
    'Воспользоваться сертификатом можно только в винотеках Simplewine, кроме винотек Wine & Whiskey By Simple.',
    'Сумму сертификата нужно потратить за один раз: оставшиеся средства сгорают.',
    'Если стоимость мероприятия с дегустацией больше, чем номинал карты, то необходимую сумму можно доплатить банковской картой или наличными.',
    'Оплачивать покупку можно несколькими подарочными сертификатами.',
    'Утерянный сертификат нельзя восстановить или обменять на деньги.',
    'Срок действия — один год с момента покупки.',
];

export const BUY_CERTIFICATE_BUTTON_TEXT = 'Купить сертификат';
